export default __webpack_public_path__ + "static/sap-a392c95483fa1457ab2ab72da0e5ac96.png";